import { getFileBaseUrl } from '@/api/files/api';
import { getImagePreviewSrc } from '../helpers';
import { Attachment } from '@/library/types/files';
import { imageUrlSelector } from '@/library/utils/image-size';
import { FC } from 'react';

type ImageProps = {
  file?: Attachment;
};

const Image: FC<ImageProps> = ({ file }) => {
  const previewImageBaseUrl = getFileBaseUrl();
  const imageSrc = file
    ? getImagePreviewSrc(imageUrlSelector({ file, label: 'gallery_small' }), previewImageBaseUrl)
    : null;

  return (
    <div
      className="gallery__footer--item-image"
      style={{
        backgroundImage: imageSrc ? `url(${imageSrc})` : undefined
      }}
    />
  );
};

export default Image;
